<template>
  <div class="role_warp">
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-delete"
        @click="bulkDelete"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getList"
      >刷新</el-button>
    </div>

    <div class="head_search">
      <div class="item_warp">
        <span>名称</span>
        <el-input
          v-model.trim="searchName"
          size="mini"
          clearable
          style="width: 180px; margin-left: 8px"
          placeholder="请输入名称"
        />
      </div>
      <el-button type="primary" size="mini" class="edit-button" @click="doFilter">
        筛选
      </el-button>
    </div>

    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="filteredList"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1331px"
      height="calc(100vh - 240px)"
      size="mini"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="name" label="名称" width="180" />
      <el-table-column label="激活图片" width="180">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.activeImgUrl"
            fit="contain"
            style="width: 50px; height: 50px"
            :preview-src-list="toArrayEvent(scope.row.activeImgUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column label="未激活图片" width="180">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.inactiveImgUrl"
            fit="contain"
            style="width: 50px; height: 50px"
            :preview-src-list="toArrayEvent(scope.row.inactiveImgUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="status" label="是否启用" width="120">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.status ? '#67C23A' : '#e74c3c' }">
            {{ Number(scope.row.status) === 1 ? '启用' : '禁用' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="120" />
      <el-table-column label="创建时间" width="220">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), '{y}-{m}-{d} {h}:{i}:{s}')
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="open('edit', scope.row)"
          >编辑</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="removeOne(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="isEdit ? '编辑' : '添加'"
      :visible.sync="dialogVisible"
      width="760px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formRef"
        :model="formData"
        :rules="rules"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model.trim="formData.name" style="width: 300px" />
        </el-form-item>
        <el-form-item label="激活图片" prop="activeImgUrl">
          <uploadPic
            :my-url="formData.activeImgUrl"
            :width="80"
            :height="80"
            :enable-preview-delete="true"
            @upLoadImage="(url) => handleUpload('activeImgUrl', url)"
          />
          <div class="upload_tip">权益激活展示的图片</div>
        </el-form-item>
        <el-form-item label="未激活图片" prop="inactiveImgUrl">
          <uploadPic
            :my-url="formData.inactiveImgUrl"
            :width="80"
            :height="80"
            :enable-preview-delete="true"
            @upLoadImage="(url) => handleUpload('inactiveImgUrl', url)"
          />
          <div class="upload_tip">权益未激活展示的图片</div>
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="formData.sort" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item>
          <el-button style="margin-right: 10px" @click="dialogVisible = false">
            取消
          </el-button>
          <el-popconfirm title="是否确定保存？" @onConfirm="isEdit ? edit() : add()">
            <el-button slot="reference" type="primary" class="edit-button">
              保存
            </el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import uploadPic from '@/components/Upload/UploadPic'
import {
  getMemberBenefitList,
  addMemberBenefit,
  updateMemberBenefit,
  removeMemberBenefit
} from '@/api/activity/memberBenefit'

function createDefaultForm() {
  return {
    id: '',
    name: '',
    activeImgUrl: '',
    inactiveImgUrl: '',
    status: 1,
    sort: 0
  }
}

export default {
  name: 'MemberBenefit',
  components: { uploadPic },
  data() {
    return {
      loading: false,
      saveLoading: false,
      searchName: '',
      showtabelData: [],
      filteredList: [],
      multipleSelection: [],
      dialogVisible: false,
      isEdit: false,
      formData: createDefaultForm(),
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        activeImgUrl: [{ required: true, message: '请上传激活图片', trigger: 'change' }],
        inactiveImgUrl: [{ required: true, message: '请上传未激活图片', trigger: 'change' }],
        status: [{ required: true, message: '请选择是否启用', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    toArrayEvent(item) {
      return [item]
    },
    applyFilter() {
      const keyword = this.searchName.trim()
      if (!keyword) {
        this.filteredList = [...this.showtabelData]
        return
      }
      this.filteredList = this.showtabelData.filter((item) =>
        String(item.name || '').includes(keyword)
      )
    },
    doFilter() {
      this.applyFilter()
    },
    getList() {
      this.loading = true
      getMemberBenefitList()
        .then((res) => {
          this.showtabelData = Array.isArray(res) ? res : []
          this.applyFilter()
        })
        .catch((err) => {
          this.$message.error(err || '服务端异常，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    open(type, row) {
      this.formData = createDefaultForm()
      if (type === 'add') {
        this.isEdit = false
      } else {
        this.isEdit = true
        this.formData = {
          id: row.id,
          name: row.name || '',
          activeImgUrl: row.activeImgUrl || '',
          inactiveImgUrl: row.inactiveImgUrl || '',
          status: Number(row.status) === 0 ? 0 : 1,
          sort: Number(row.sort) || 0
        }
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    handleUpload(field, url) {
      this.formData[field] = url
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField(field)
      })
    },
    buildPayload() {
      return {
        id: this.formData.id,
        name: this.formData.name,
        activeImgUrl: this.formData.activeImgUrl,
        inactiveImgUrl: this.formData.inactiveImgUrl,
        status: Number(this.formData.status),
        sort: Number(this.formData.sort)
      }
    },
    add() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        const payload = this.buildPayload()
        delete payload.id
        this.saveLoading = true
        addMemberBenefit(payload)
          .then(() => {
            this.$message.success('添加成功')
            this.dialogVisible = false
            this.getList()
          })
          .catch((err) => {
            this.$message.error(err || '添加失败')
          })
          .finally(() => {
            this.saveLoading = false
          })
      })
    },
    edit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        const payload = this.buildPayload()
        this.saveLoading = true
        updateMemberBenefit(payload)
          .then(() => {
            this.$message.success('更新成功')
            this.dialogVisible = false
            this.getList()
          })
          .catch((err) => {
            this.$message.error(err || '更新失败')
          })
          .finally(() => {
            this.saveLoading = false
          })
      })
    },
    removeOne(row) {
      this.$confirm('是否删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => removeMemberBenefit({ ids: [row.id] }))
        .then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
        .catch(() => {})
    },
    bulkDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请勾选要删除的选项')
        return
      }
      this.$confirm('是否删除选中数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const ids = this.multipleSelection.map((item) => item.id)
          return removeMemberBenefit({ ids })
        })
        .then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
}
.role_heard_tool {
  margin-bottom: 12px;
}
.head_search {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.item_warp {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.upload_tip {
  margin-top: 6px;
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}
</style>
